import { SKELETON_KEY, SKELETON_KEY_DATE, SKELETON_KEY_NUMBER } from './skeletonFactory';

export function skeletonReaderRequest() {
  return {
    id: SKELETON_KEY,
    reader: SKELETON_KEY,
    product: SKELETON_KEY,
    requestDate: SKELETON_KEY_DATE,
    receptionDate: SKELETON_KEY_DATE,
    requestStatus: SKELETON_KEY,
    requestType: SKELETON_KEY,
    ringAmount: SKELETON_KEY_NUMBER,
    responseFileUrl: SKELETON_KEY
  };
}
